var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-3 py-2"},[_c('b-row',{staticClass:"align-items-center"},[_c('b-col',{attrs:{"sm":"4"}},[_c('BuildingDropdown',{attrs:{"server-params":_vm.serverParams,"on-select":_vm.onChange}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }